module.exports = __webpack_public_path__ + "static/media/tgs.ecd7bb7a.jpeg";